// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"aed57bbd","198":"b6f6b946","345":"0694e7eb","404":"309e4d11","415":"18346728","498":"be63b2b1","733":"d491c399"}[chunkId] + ".chunk.js";
};